/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Prices_RemovedInputs */

const en_field_prices_removed = /** @type {(inputs: Field_Prices_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prices outside the Price Setup removed`)
};

/**
* | output |
* | --- |
* | "Prices outside the Price Setup removed" |
*
* @param {Field_Prices_RemovedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const field_prices_removed = /** @type {((inputs?: Field_Prices_RemovedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Prices_RemovedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_field_prices_removed(inputs)
});